'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RestErrors = undefined;

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _commonErrors, _extends2, _extends3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let getErrorByStatus = res => code => res[code] === false ? false : res[code] ? res[code] : 'unknown error';
let http200 = 200;
let http201 = 201;
let http204 = 204;
let http404 = 404;
let http500 = 500;
let commonErrors = (_commonErrors = {}, (0, _defineProperty3.default)(_commonErrors, http200, false), (0, _defineProperty3.default)(_commonErrors, http404, 'communication error'), (0, _defineProperty3.default)(_commonErrors, http500, 'server issue'), _commonErrors);
let create = getErrorByStatus((0, _extends6.default)({}, commonErrors, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, http201, false), (0, _defineProperty3.default)(_extends2, http204, false), _extends2)));
let list = getErrorByStatus((0, _extends6.default)({}, commonErrors));
let read = getErrorByStatus((0, _extends6.default)({}, commonErrors));
let remove = getErrorByStatus((0, _extends6.default)({}, commonErrors, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, http204, false), (0, _defineProperty3.default)(_extends3, http404, false), _extends3)));
let update = getErrorByStatus((0, _extends6.default)({}, commonErrors, (0, _defineProperty3.default)({}, http204, false)));
let RestErrors = exports.RestErrors = {
    create: create,
    list: list,
    read: read,
    remove: remove,
    update: update
};
//# sourceMappingURL=RestErrors.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/RestErrors.js